import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3000';
const BASE = `${API_BASE}/webtool/notifications`;

export async function listNotificationHistory() {
  const res = await axios.get(BASE);
  return res.data;
}

export async function sendAddonNotification(addonId, confirmResend = false) {
  const res = await axios.post(`${BASE}/send`, { addonId, confirmResend });
  return res.data;
}
